const BYOB_PUBSUB_EVENTS = {
  CARD_CHANGE: 'CARD_CHANGE',
}

customElements.define('byob-dashboard', class ByobDashboard extends HTMLElement {
  constructor() {
    super();
    
    this.products = [];
  }
  
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.bundleSize = parseInt(this.dataset.bundleSize);
    
    this.subscriptionWidget = this.querySelector('byob-subscription-widget');
    this.cartItems = document.querySelector('cart-items');
    this.submitButton = this.querySelector('[type="submit"]');
    this.form = this.querySelector('form');
    
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    
    subscribe(BYOB_PUBSUB_EVENTS.CARD_CHANGE, this.onChange.bind(this));
    
    if (this.submitButton) {
      this.submitButton.closest('[data-quick-add-holder]')
          .addEventListener('theme:cart:error', this.handleErrorMessage.bind(this));
    }
  }
  
  onSubmit(event) {
    event.preventDefault();
    
    const bundlePropertiesList = this.products.map(variant => `${variant.name}:1`);
    
    const formData = new FormData(this.form);
    
    const mainProductHandle = formData.get('bundle_handle');
    const mainProductName = formData.get('bundle_name');
    const sellingPlanId = formData.get('selling_plan');
    const purchaseOption = formData.get('purchase_option');
    const uniqByobId = Math.random().toString(16).slice(2);
    
    const bundleFormData = new FormData();
    bundleFormData.append('sections', 'cart-drawer');
    bundleFormData.append('sections_url', window.location.pathname);
    
    this.products.forEach((variant, index) => {
      bundleFormData.append(`items[${index}][id]`, variant.id);
      bundleFormData.append(`items[${index}][selling_plan]`, sellingPlanId);
      bundleFormData.append(`items[${index}][purchase_option]`, purchaseOption);
      bundleFormData.append(`items[${index}][quantity]`, 1);
      bundleFormData.append(`items[${index}][properties][Bundle]`, mainProductName);
      bundleFormData.append(`items[${index}][properties][Bundle ID]`, uniqByobId);
      bundleFormData.append(`items[${index}][properties][_byob_main_product_handle]`, mainProductHandle);
      bundleFormData.append(`items[${index}][properties][_byob_index]`, index);
      bundleFormData.append(`items[${index}][properties][_byob_products_list]`, bundlePropertiesList.join(' ; '));
    });
    
    this.cartItems.addToCart(bundleFormData, this.submitButton);
  }
  
  handleErrorMessage(event) {
    const errorMessageWrapper = this.querySelector('.byob-dashboard-error');
    if (!event.detail.description || !errorMessageWrapper)  return;
    
    errorMessageWrapper.toggleAttribute('hidden', !event.detail.description);
    errorMessageWrapper.textContent = event.detail.description;
    
    setTimeout(() => {
      errorMessageWrapper.textContent = '';
      errorMessageWrapper.setAttribute('hidden', '');
    }, 5000);
  }
  
  addProduct(variant) {
    if (!variant) return;
    this.products.push(variant);
    publish(BYOB_PUBSUB_EVENTS.CARD_CHANGE, this.products);
  }
  
  removeProduct(id) {
    if (!id)  return;
    const index = this.products.findIndex(item => item.id === parseInt(id));
    this.products.splice(index, 1);
    publish(BYOB_PUBSUB_EVENTS.CARD_CHANGE, this.products);
  }
  
  isBundleFull() {
    return this.products.length >= this.bundleSize;
  }
  
  isProductAdded(id) {
    if (!id)  return;
    return this.products.some(item => item.id === parseInt(id));
  }
  
  getAddedProductsById(id) {
    return this.products.filter(item => item.id === parseInt(id));
  }
  
  onChange(products) {
    const productsCount = products.length;
    const byobItems = this.querySelectorAll('byob-item');
    
    if (this.submitButton) this.submitButton.disabled = productsCount < this.bundleSize;
    
    byobItems.forEach((item, index) =>
      products[index] ? item.setProduct(products[index]) : item.removeProduct(),
    );
  }
});

customElements.define('byob-product-card', class ByobProductCard extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.dashboard = document.querySelector(`byob-dashboard[data-section="${this.dataset.section}"]`);
    this.quantityInput = this.querySelector('[name="quantity"]');
    this.addButton = this.querySelector('[data-add-byob-product]');
    this.chooseOptionButton = this.querySelector('[data-choose-option-byob-product]');
    this.variantList = this.querySelector('[data-dropdown-list]');
    this.variantListItems = this.variantList ? this.variantList.querySelectorAll('[data-dropdown-option]') : [];
    
    if (!this.dashboard)  return;
    
    try {
      const scriptJSON = this.querySelector('[type="application/json"]');
      this.productJSON = JSON.parse(scriptJSON.innerHTML);
    } catch(error) {
      throw new Error('There was an error when try to parse product JSON.');
    }
    
    if (this.addButton) this.addButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.chooseOptionButton) this.chooseOptionButton.addEventListener('click', this.onChooseVariantButtonClick.bind(this));
    if (this.quantityInput) this.quantityInput.addEventListener('change', this.onQuantityChange.bind(this));

    if (this.variantListItems.length) {
      this.variantListItems.forEach(option => {
        option.addEventListener('click', this.addVariant.bind(this));
      });
    }
    
    subscribe(BYOB_PUBSUB_EVENTS.CARD_CHANGE, this.cardValidation.bind(this));
  }

  onChooseVariantButtonClick(event) {
    event.preventDefault();
    this.toggleVariantList();
  }

  toggleVariantList() {
    this.variantList.classList.toggle('hidden');
  }

  addVariant(event) {
    const target = event.target;
    const datasetVariantId = target.dataset.variantId;
    const variantId = Number(datasetVariantId);
    const variant = this.getVariantId(variantId);
  
    if (!variant) {
      console.error('Variant not found');
      return;
    }
  
    this.add({
      ...variant,
      featured_image: this.productJSON.featured_image,
    });

    this.toggleVariantList();
  }

  getVariantId(variantId) {
    return this.productJSON.variants.find(v => v.id === variantId);
  }

  
  onButtonClick(event) {
    event.preventDefault();
    this.classList.add('byob-product-added');
    this.quantityInput.stepUp();
    this.quantityInput.dispatchEvent(new Event('change'));
  }
  
  onQuantityChange(event) {
    const target = event.target;
    const inputQuantityValue = parseInt(target.value);
    const variantId = this.productJSON.variants[0].id;
    const addedProducts = this.dashboard.getAddedProductsById(variantId);
    
    //TODO MAKE QUANTITY CHANGE INSTEAD OF READONLY
    if (inputQuantityValue > addedProducts.length) {
      this.add({
        ...this.productJSON.variants[0],
        featured_image: this.productJSON.featured_image,
      });
    } else {
      this.remove(variantId);
    }
  }
  
  add(variant) {
    this.dashboard.addProduct(variant);
  }
  
  remove(variantId) {
    this.dashboard.removeProduct(variantId);
  }
  
  cardValidation() {
    const variantId = this.productJSON.variants[0].id;
    const isProductAdded = this.dashboard.isProductAdded(variantId);
    const addedProductLength = this.dashboard.getAddedProductsById(variantId).length;
    
    this.disable(this.dashboard.isBundleFull());

    if (this.addButton) {
      this.classList.toggle('byob-product-added', isProductAdded);
    }

    if (this.quantityInput) this.quantityInput.value = addedProductLength;
  }
  
  disable(status) {
    const plusButton = this.querySelector('[name="increase"]');
    
    if (this.addButton) this.addButton.disabled = status;
    if (this.quantityInput) this.quantityInput.disabled = status;
    if (plusButton) plusButton.disabled = status;
    if (this.chooseOptionButton) this.chooseOptionButton.disabled = status;
  }
});

customElements.define('byob-item', class ByobItem extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    const filledTemplate = this.querySelector('[id*="byob-item-template-filled--"]');
    const emptyTemplate = this.querySelector('[id*="byob-item-template-empty-state--"]');
    
    this.removeButton = null;
    this.dashboard = document.querySelector('byob-dashboard');
    this.content = this.querySelector('.byob-item__product');
    
    this.filledTemplateContent = filledTemplate.content;
    this.emptyTemplateContent = emptyTemplate.content;
  }
  
  onRemove() {
    if (!this.removeButton || !this.variantId) return;
    this.dashboard.removeProduct(this.variantId);
  }
  
  setProduct(variant) {
    if (!variant) return;
    
    const layout = this.filledTemplateContent.cloneNode(true);
    const removeButton = this.removeButton = layout.querySelector('.byob-item__remove');
    const image = layout.querySelector('.byob-item__media img');
    const heading = layout.querySelector('.byob-item__heading');
    
    image.setAttribute('srcset', image.getAttribute('srcset').replaceAll('{{image}}', this.getLazyImageSource(variant.featured_image, [25, 36, 72, 144])));
    image.setAttribute('src', image.getAttribute('src').replaceAll('{{image}}', this.getLazyImageSource(variant.featured_image, [10])));
    image.setAttribute('alt', image.getAttribute('alt').replaceAll('{{alt}}', variant.title));
    heading.innerHTML = variant.name;
    
    this.content.innerHTML = '';
    this.content.appendChild(layout);
    this.classList.remove('is-empty');
    this.variantId = variant.id;
    
    if (removeButton)  removeButton.addEventListener('click', this.onRemove.bind(this), { once: true });
  }
  
  removeProduct() {
    this.content.innerHTML = '';
    this.content.appendChild(this.emptyTemplateContent.cloneNode(true));
    this.classList.add('is-empty');
  }
  
  getLazyImageSource(imageUrl, sizes) {
    const imageUrlParts = imageUrl.split('.');
    const imageExtension = imageUrlParts.pop();
    const imagePath = imageUrlParts.join('.');
    return sizes.map(size => `${imagePath}_${size}x.${imageExtension} ${size}w`).join(', ');
  }
});

customElements.define('byob-dashboard-info', class ByobDashboardInfo extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    subscribe(BYOB_PUBSUB_EVENTS.CARD_CHANGE, this.updateInformation.bind(this));
  }
  
  updateInformation(products) {
    const infoElement = this.querySelector('[data-info-message] .byob-dashboard__message--has-products span');
    const infoElementLabel = this.querySelector('[data-info-message] .byob-dashboard__message--has-products span.product-label');
    const bundleSize = parseInt(document.querySelector('[data-bundle-size]')?.dataset.bundleSize, 10);
    const hasProductEl = document.querySelector('.byob-dashboard__message--has-products');
    const readyProductEl = document.querySelector('.byob-dashboard__message--ready-bundle');
    const emptyBundleEl = document.querySelector('.byob-dashboard__message--empty');

    
    if (infoElement) infoElement.innerHTML = products.length;

    console.log('Products in bundle:', products.length);

    if (products.length >= bundleSize) {
      hasProductEl.style.display = "none";
      readyProductEl.style.display = "block";
      emptyBundleEl.style.display = "none";
    } else if (products.length > 0) {
      infoElementLabel.innerHTML = products.length > 1 ? 'products' : 'product';
      hasProductEl.style.display = "block";
      readyProductEl.style.display = "none";
      emptyBundleEl.style.display = "none";
    } else {
      hasProductEl.style.display = "none";
      readyProductEl.style.display = "none";
      emptyBundleEl.style.display = "block";
    }
    
    this.setAttribute('data-has-products', !!products.length);
  }
});

customElements.define('byob-subscription-widget', class ByobSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    
    this.productJSON = JSON.parse(this.querySelector('script[type="application/json"]').innerHTML);
    
    this.groupId = "";
    this.planId = "";
  }
  
  connectedCallback() {
    this.sellingPlanGroupInput = this.querySelectorAll('[data-skio-selling-plan-group-input]');
    this.sellingPlanInput = this.querySelector('[data-skio-selling-plan-input]');
    this.plansSelect = this.querySelector('[data-skio-selling-plans-select]');
    
    this.groupChange(true);

    if (this.sellingPlanInput) this.sellingPlanInput.value = "";
    
    this.addEventListener('change', this.onGroupChange.bind(this));
    this.plansSelect.addEventListener('change', this.onPlanChange.bind(this));
    
    subscribe(BYOB_PUBSUB_EVENTS.CARD_CHANGE, this.onBundleChange.bind(this));
  }
  
  onBundleChange(variants) {
    const oneTimePrice = this.querySelector('[data-skio-selling-plan-group-id].skio-otp [data-skio-subscribe-price]');
    const oneTimeComparePrice = this.querySelector('[data-skio-selling-plan-group-id].skio-otp [data-skio-compare-price]');
    const subscriptionPrice = this.querySelector('[data-skio-selling-plan-group-id]:not(.skio-otp) [data-skio-subscribe-price]');
    const subscriptionComparePrice = this.querySelector('[data-skio-selling-plan-group-id]:not(.skio-otp) [data-skio-compare-price]');
    
    const price = variants.reduce((acc, variant) => {
      const sellingPlan = variant.selling_plan_allocations.find(
          plan => plan.selling_plan_id === Number(this.planId)
      );
      
      if (!sellingPlan) return acc;
      
      return {
        regular_price: acc.regular_price + variant.price,
        subscription_price: acc.subscription_price + sellingPlan.price
      };
    }, { regular_price: 0, subscription_price: 0 });
    
    if (oneTimePrice) oneTimePrice.innerHTML = window.formatMoney(price.regular_price, theme.moneyFormat);
    if (subscriptionComparePrice) subscriptionComparePrice.innerHTML = window.formatMoney(price.regular_price, theme.moneyFormat);
    if (subscriptionPrice) subscriptionPrice.innerHTML = window.formatMoney(price.subscription_price, theme.moneyFormat);
  }
  
  onGroupChange(event) {
    const target = event.target;
    
    if (target.name === 'purchase_option' && this.plansSelect) {
      this.groupId = target.value;
      this.groupChange(target.value === "");
      
      this.sellingPlanGroupInput.forEach(input => {
        const parentOption = input.closest('[data-skio-selling-plan-group-id]');
        
        if (input.value === target.value) {
          input.setAttribute('checked', true);
          if (parentOption) parentOption.classList.add('selected-plan');
        } else {
          input.removeAttribute('checked');
          if (parentOption) parentOption.classList.remove('selected-plan');
        }
      });
    }
  }
  
  onPlanChange(event) {
    const target = event.target;
    
    this.sellingPlanInput.value = target.value;
    this.planId = target.value;
  }
  
  groupChange(oneTimeSelect) {
    if (oneTimeSelect) {
      this.plansSelect.disabled = true;
      this.sellingPlanInput.value = "";
    } else {
      this.plansSelect.disabled = false;
      this.sellingPlanInput.value = this.plansSelect.value;
    }
    this.planId = this.plansSelect.value;
  }
});
